import { CmtsMasterDataCrudShell } from "../components/master-data/index.js";

export function ReferenceTypePage() {
  return <CmtsMasterDataCrudShell entityKey="reference-type" />;
}

export default ReferenceTypePage;
